import React from 'react';

import { useBrandingContext, useNextyContext } from 'containers/App/hooks';

export const withContext = (Component: any) => (props: any) => {
  const brandingContextValues = useBrandingContext();
  const nextyContextValues = useNextyContext();

  return <Component {...props} brandingContextValues={brandingContextValues} nextyContextValues={nextyContextValues} />;
};
